<template>
    <div>
      <h2 class="text-1xl font-bold text-gray-700">
        Módulo de usuarios
      </h2>
      <MainUsers />
    </div>
  </template>
  
  <script>
  import MainUsers from "@/components/Users/Main/MainUsers.vue";
import { useRoute } from 'vue-router';
import { onBeforeMount, onMounted } from 'vue';
import { findSubmoduleIdByDescription } from '@/hisAcces';
  export default {
    name: "MainUser",
    components: {
        MainUsers,
    },
  setup() {
    const route = useRoute();
    onBeforeMount(() => {
      if (!findSubmoduleIdByDescription(route.path)) {
        window.location.href = "/login";
      }
    });

    onMounted(() => {
      document.title =
        route.meta.title + process.env.VUE_APP_TITLE ||
        process.env.VUE_APP_TITLE;
    });
  },
  };
  </script>